import { FormValidator } from '../lib/FormValidator';

document.addEventListener('DOMContentLoaded', () => {
  const $useLearnersProfile = $('#signup_use_learners_profile');
  const learnersProfile = $('#learners_profile_holder').data(
    'learners-profile',
  );
  const prevProfile: { [key: string]: any } = {};

  const keyToSelector = (key: string): string => {
    return '#signup_' + key;
  };

  const setValueToElement = (
    $e: JQuery<HTMLElement>,
    key: string,
    value: any,
  ): void => {
    if (key.match(/^birth_/)) {
      $e.val(value).trigger('change');
    } else {
      $e.val(value);
    }
  };

  const getValidator = (): FormValidator => {
    const definition = $('#validation_definition_holder').data(
      'validation-definition',
    );

    const rules = $.extend(true, definition.rules, {
      'signup[last_name]': {
        remote:
          FormValidator.ajaxValidationParams.textValidation(
            'signup[last_name]',
          ),
      },
      'signup[first_name]': {
        remote:
          FormValidator.ajaxValidationParams.textValidation(
            'signup[first_name]',
          ),
      },
    });

    const validator = new FormValidator(
      $('#new_signup'),
      rules,
      definition.messages,
    );
    const $selectFields = $(
      "select[name='signup[birth_year]'], select[name='signup[birth_month]'], select[name='signup[birth_day]']",
    );
    validator.setValidation($selectFields);
    return validator;
  };

  if ($('.aya-signup-form').is(':visible')) {
    const validator = getValidator();

    $('#signup_use_learners_profile').on('change', () => {
      if ($useLearnersProfile.is(':checked')) {
        for (const key in learnersProfile) {
          const value = learnersProfile[key];
          const $e = $(keyToSelector(key));
          prevProfile[key] = $e.val();
          setValueToElement($e, key, value);

          validator.validateElement($e[0]);
        }
      } else {
        for (const key in learnersProfile) {
          const $e = $(keyToSelector(key));
          setValueToElement($e, key, prevProfile[key]);

          validator.validateElement($e[0]);
        }
      }
    });

    // select default birth year
    const defaultYear = '1975';
    const $birthYear = $('select[name="signup[birth_year]"]');

    $birthYear.one('select2:open', () => {
      $birthYear.val(defaultYear);
    });

    $birthYear.one('select2:close', (e: JQuery.TriggeredEvent) => {
      if (e.target.value === defaultYear) {
        $birthYear.trigger('change');
      }
    });
  }
});
